import {
  Box,
  Grid,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Select,
} from "@mui/material";
import React from "react";
import {
  Edit,
  ImageField,
  SelectField,
  SelectInput,
  SimpleForm,
  useRecordContext,
  useRefresh,
} from "react-admin";
import LinkToBankProducts from "../partners/LinkToBankProducts";
import HmTextInput from "../unit/HmTextInput";
import formatPhone from "../unit/inputFormat/formatPhone";
import parseNumber from "../unit/inputFormat/parseNumber";
import parsePhone from "../unit/inputFormat/parsePhone";
import validateNumber from "../unit/inputFormat/validateNumber";
import YesNoInput from "../unit/YesNoInput";
import useNotify from "../unit/useNotify";
import sendRequest from "../dataProvider/sendRequest";
import { CopyAllOutlined } from "@mui/icons-material";
import RefreshIcon from "@mui/icons-material/Refresh";
import CustomSelect from "../unit/forms/CustomSelect";
import UploadImage from "../unit/UploadImage";
const ShowOriginalName = () => {
  const record = useRecordContext();
  return (
    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
      Coupon Code : {record?.sCode}
    </Typography>
  );
};

const CouponCodeLinkReadonly = () => {
  const record = useRecordContext();
  const id = record?.id;
  const [couponcodeToken, setCouponcodeToken] = React.useState(
    record?.sCode || ""
  );
  const { success } = useNotify();
  const handleClick = () => {
    let reqUrl = "/general/couponcodelink";
    sendRequest(reqUrl, { id: id }).then((response) => {
      if (response) {
        setCouponcodeToken(response?.random_code);
      }
    });
  };
  const handleCopy = () => {
    navigator.clipboard.writeText(couponcodeToken);
    success("Link copied to clipboard");
  };
  return (
    <Box>
      <TextField
        id="outlined-basic"
        label="Coupon Code"
        variant="outlined"
        value={couponcodeToken}
        sx={{
          width: "100%",
          "& input.Mui-readOnly": {
            backgroundColor: "#ddd",
            borderRadius: "10px",
          },
        }}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={"Generate Code"}
                onClick={handleClick}
                edge="end"
                disabled={couponcodeToken ? true : false}
              >
                <RefreshIcon color={couponcodeToken ? "disabled" : "primary"} />
              </IconButton>

              {/* <IconButton
                aria-label={"Copy Code"}
                onClick={handleCopy}
                edge="end"
                sx={{ marginLeft: "20px" }}
              >
                <CopyAllOutlined color="primary" />
              </IconButton> */}
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

const CouponCodeEdit = (props: any) => {
  const [activeTab, setActiveTab] = React.useState(0);
  const [securitySignup, setSecuritySignup] = React.useState("");
  const [signLanguage, setSignLanguage] = React.useState("en");
  const [showEditAccountSection, setShowEditAccountSection] =
    React.useState(false);
  const curTab = props?.curTab;
  const productList = props?.productList;
  const handleChange = (newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Edit
      {...props}
      basePath="/couponcodes"
      resource="couponcodes"
      sx={{
        marginTop: "0px",
        ".MuiPaper-root": { border: "none", borderRadiue: "none" },
      }}
      className="couponcode_edit_dialog_form"
    >
      <SimpleForm toolbar={false} sx={{ paddingTop: "0px" }}>
        <Box sx={{ width: "100%", pt: 0 }}>
          <>
            {curTab && curTab == "info" && (
              <Box
                sx={{
                  pt: 0,
                  pb: 2,
                }}
                id="couponcode-edit-info-tab"
              >
                <CouponCodeLinkReadonly />
                <HmTextInput
                  source="fValue"
                  label="Reduction"
                  required={true}
                  sx={{ width: "79%" }}
                />
                <SelectInput
                  source="sType"
                  label="Type"
                  variant="outlined"
                  choices={[
                    { id: "amount", name: "$" },
                    {
                      id: "discount",
                      name: "%",
                    },
                  ]}
                  required={true}
                  helperText={false}
                  sx={{ width: "20%", marginLeft: "1%" }}
                />
                {/* Activation Date */}
                <HmTextInput
                  source="dtStart"
                  label="Activation Date"
                  required={true}
                  type="date"
                  InputLabelProps={{ shrink: true }}
                />
                <HmTextInput
                  source="dtEnd"
                  label="Expiration Date"
                  required={true}
                  type="date"
                  InputLabelProps={{ shrink: true }}
                />
              </Box>
            )}

            {curTab && curTab == "linkProducts" && (
              <Box
                sx={{
                  pt: 2,
                  pb: 2,
                }}
                id="couponcode-edit-linkproducts-tab"
              >
                <LinkToBankProducts productList={productList} />
              </Box>
            )}
          </>
        </Box>
      </SimpleForm>
    </Edit>
  );
};

export default CouponCodeEdit;
